import React, { FC } from 'react';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { styled } from 'linaria/react';
import { OldBreadcrumbs } from '@widgets/Breadcrumbs';
import { Content } from '@shared/ui/atoms';
import FullViewportHeightSection from './FullViewportHeightSection';
import SectionBg from './SectionBg';
import TakeParticipationButton from './TakeParticipationButton';
import heroBgDesktop from '../../assets/new-year/hero-bg-desktop.jpg';
import heroBgTablet from '../../assets/new-year/hero-bg-tablet.jpg';
import heroBgMobile from '../../assets/new-year/hero-bg-mobile.jpg';
import characterImg from '../../assets/new-year/character.png';
import ballImg from '../../assets/new-year/ball.png';
import starImg from '../../assets/new-year/star.png';
const DynamicScrollDownAnimation = dynamic(() => import('./ScrollDownAnimation').then(imported => imported.default), {
  loading: () => <div />,
  ssr: false
});
const HeroSectionView: FC = () => <FullViewportHeightSection>
    <SectionBg desktopImg={heroBgDesktop} tabletImg={heroBgTablet} mobileImg={heroBgMobile}>
      <HeroSectionViewWrapper>
        <BreadcrumbsWrapperOuter>
          <Content.Padding left={40} right={40} mobLeft={24} mobRight={24} minLeft={20} minRight={20}>
            <BreadcrumbsWrapperInner>
              <OldBreadcrumbs />
            </BreadcrumbsWrapperInner>
          </Content.Padding>
        </BreadcrumbsWrapperOuter>
        <BallImageWrapper>
          <Image src={ballImg} alt="Шар" width={107} height={205} />
        </BallImageWrapper>
        <StarImageWrapper>
          <Image src={starImg} alt="Звезда" width={164} height={244} />
        </StarImageWrapper>
        <TextWrapper>
          <HeroText>НОВОГОДНИЙ РОЗЫГРЫШ</HeroText>
          <Subtitle>Steam</Subtitle>
        </TextWrapper>
        <CharacterWrapper>
          <Image src={characterImg} alt="Розыгрыш Steam" width={966} height={817} />
        </CharacterWrapper>
        <TakeParticipationButtonWrapper>
          <TakeParticipationButton withSnow />
        </TakeParticipationButtonWrapper>
        <ScrollDownWrapper>
          <DynamicScrollDownAnimation />
        </ScrollDownWrapper>
      </HeroSectionViewWrapper>
    </SectionBg>
  </FullViewportHeightSection>;
export default HeroSectionView;
const HeroSectionViewWrapper = /*#__PURE__*/styled('div')({
  name: "HeroSectionViewWrapper",
  class: "h1t28cft",
  propsAsIs: false
});
const BreadcrumbsWrapperOuter = /*#__PURE__*/styled('div')({
  name: "BreadcrumbsWrapperOuter",
  class: "bjxkhb7",
  propsAsIs: false
});
const BreadcrumbsWrapperInner = /*#__PURE__*/styled('div')({
  name: "BreadcrumbsWrapperInner",
  class: "b1heuffc",
  propsAsIs: false
});
const BallImageWrapper = /*#__PURE__*/styled('div')({
  name: "BallImageWrapper",
  class: "b133smts",
  propsAsIs: false
});
const StarImageWrapper = /*#__PURE__*/styled('div')({
  name: "StarImageWrapper",
  class: "s9565c6",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "tzppitw",
  propsAsIs: false
});
const HeroText = /*#__PURE__*/styled('h1')({
  name: "HeroText",
  class: "h10febt3",
  propsAsIs: false
});
const Subtitle = /*#__PURE__*/styled('p')({
  name: "Subtitle",
  class: "saldskj",
  propsAsIs: false
});
const CharacterWrapper = /*#__PURE__*/styled('div')({
  name: "CharacterWrapper",
  class: "c1frz32g",
  propsAsIs: false
});
const TakeParticipationButtonWrapper = /*#__PURE__*/styled('div')({
  name: "TakeParticipationButtonWrapper",
  class: "tbi38b9",
  propsAsIs: false
});
const ScrollDownWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollDownWrapper",
  class: "s1mos66r",
  propsAsIs: false
});

require("./HeroSectionView.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./HeroSectionView.tsx");